<template>
  <div class="mpage">
    <div class="mpage_c">
      <div class="title">
        <div class="lef_p"><img src="@/assets/images/nav_head_bg1.png"></div>
        联系我们
        <div class="rig_P"><img src="@/assets/images/nav_head_bg2.png"></div>
      </div>
      <div class="mini_title">CALL ME</div>
      <div class="call_c">
        <div class="c_lef">
          <div class="call_info">
            <div class="info_c">
              <div class="com">
                <img src="@/assets/images/call-p1.png" alt="">联系人
              </div>
              <font>刘先生</font>
            </div>
            <div class="info_c">
              <div class="com">
                <img src="@/assets/images/call-p2.png" alt="">联系电话
              </div>
              <font>0591-88888888</font>
            </div>
            <div class="info_c">
              <div class="com">
                <img src="@/assets/images/call-p3.png" alt="">联系邮箱
              </div>
              <font>18860147078@163.com</font>
            </div>
          </div>
          <div class="map_c">
<!--            <img src="@/assets/images/map-p.png" alt="">-->
          </div>
        </div>
        <!-- 二维码 -->
        <!-- <div class="c_rig">
          <div class="card_c"><img src="@/assets/images/card-p1.png" alt="">
            <font>微信服务号</font>
          </div>
          <div class="card_c"><img src="@/assets/images/card-p2.png" alt="">
            <font>商务合作</font>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  created(){
    this.$emit('header', true);
    this.$emit('footer', true);
  }
}
</script>
  
<style scoped lang="less">
.mpage {
  width: 100%;
  background: url('~@/assets/images/call-bg.png') no-repeat center top;
  background-size: 100% 100%;
  min-height: 750px;
  margin: 0 auto;
  text-align: center;

  .mpage_c {
    width: 1432px;
    margin: 0 auto;
    text-align: center;
    
    margin-bottom: 100px;

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 32px;
      color: #282828;
      padding-top: 98px;

      .lef_p {
        margin-right: 50px;
      }

      .rig_P {
        margin-left: 50px;
      }
    }

    .mini_title {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 18px;
      color: #bcbcbc;
      margin-top: 6px;
      margin-bottom: 10px;
    }

    .call_c {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 60px;

      .c_lef {
        width: 100%;

        .call_info {
          display: flex;
          align-items: center;
          padding-left: 47px;

          .info_c {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            width: 33%;
            justify-content: start;
            padding-left: 100px;

            .com {
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 18px;
              color: #282828;
              width: 100%;
              text-align: left;
              display: flex;
              // align-items: baseline;
              line-height: 62px;

              img {
                margin-right: 7px;
                width: 40px;
                height: 44px;
              }
            }

            font {
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 24px;
              color: #093E7D;
              text-align: left;
              margin-top: 4px;
            }
          }
        }

        .map_c {
          margin-top: 50px;
        }
      }

      .c_rig {
        width: 148px;
        margin-right: 60px;
        margin-top: 160px;

        .card_c {
          margin-bottom: 27px;

          font{
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #6E6F70;
            margin-top:5px;
            display: block;
          }
        }
      }
    }

  }
}</style>